import Prototype from "./Prototype";
import PrototypeImpl from "../../PrototypeImpl.ts";

export default class PrototypeInput {
  public readonly prototypes: Prototype[];
  public readonly blankId: string;

  constructor(prototypes: Prototype[], blankId: string) {
    this.prototypes = prototypes;
    this.blankId = blankId;
  }

  public static parseJsonToPrototypeInput(data: any): PrototypeInput {
    const parsedPrototypes: PrototypeImpl[] = [];
    for (const prototypeId in data) {
      const prototypeData: any = data[prototypeId];
      // console.log(prototypeData);
      const parsedPrototype: PrototypeImpl = new PrototypeImpl(
        prototypeId,
        prototypeData.mesh_name,
        prototypeData.mesh_rotation,
        prototypeData.posX,
        prototypeData.negX,
        prototypeData.posY,
        prototypeData.negY,
        prototypeData.posZ,
        prototypeData.negZ,
        prototypeData.constrain_to,
        prototypeData.constrain_from,
        prototypeData.weight,
        {
          posX: prototypeData.valid_neighbours[0],
          negX: prototypeData.valid_neighbours[2],
          posY: prototypeData.valid_neighbours[4],
          negY: prototypeData.valid_neighbours[5],
          posZ: prototypeData.valid_neighbours[3],
          negZ: prototypeData.valid_neighbours[1],
          // negX <-> posY, negX <-> posZ, posZ <-> negZ
          // posY/negY <-> posZ/negZ, posZ <-> negZ, negX <-> negZ
        },
      );
      // console.log("parsedPrototype", parsedPrototype);
      parsedPrototypes.push(parsedPrototype);
    }
    const blankId: string = parsedPrototypes[parsedPrototypes.length - 1].id;
    return new PrototypeInput(parsedPrototypes, blankId);
  }
}
